import axios from 'axios';
import ss from '../Session';

export type History = {
    serviceId: string, titleId: string,
    title: string, thumbnail: string,
    productId: string, productName?: string,
    createdAt: number, status: string, remainder: number
}[];

export const getHistory = async (): Promise<History | null> => {

    try{
        let res = await axios.post(`https://api.novela.today/purchase/history`,{},{
            headers: {
                Authorization: `Bearer ${ss.getCurrentSession().jwt}`
            },
            withCredentials: true
        });

        if ( res.data && res.data.code === 200 ) {
            return res.data.data;
        } else {
            return null;
        };

    } catch (e) {
        console.error(e);
        return null;
    }
}
